/* Keep the private-message thread genuinely scrollable on desktop.
 * The Messages page currently auto-scrolls its end anchor whenever the
 * message array changes. Once a user scrolls upward, that can yank the view
 * back to the bottom. We intercept only that anchor and only suppress the
 * auto-scroll when the reader is intentionally away from the bottom.
 */

const THREAD = '[data-testid="message-thread"]';
const BOTTOM_THRESHOLD = 120;
const PATCH_DELAY = 900;

function installAnchorGuard(thread) {
  const anchor = thread.lastElementChild;
  if (!anchor || anchor.dataset.scrollGuardInstalled === '1') return;

  anchor.dataset.scrollGuardInstalled = '1';
  const nativeScrollIntoView = Element.prototype.scrollIntoView;

  anchor.scrollIntoView = function scrollIntoViewGuard(options) {
    const distanceFromBottom = thread.scrollHeight - thread.scrollTop - thread.clientHeight;

    // At/near the bottom: preserve the existing "new message -> bottom"
    // behavior. Away from the bottom: don't destroy the user's reading spot.
    if (distanceFromBottom <= BOTTOM_THRESHOLD) {
      nativeScrollIntoView.call(this, options);
    }
  };
}

function enhanceThread(thread) {
  thread.style.overflowY = 'auto';
  thread.style.minHeight = '0';
  thread.style.overscrollBehaviorY = 'contain';
  thread.style.scrollBehavior = 'smooth';

  // Let the existing initial-load effect settle first, then guard the anchor.
  window.setTimeout(() => installAnchorGuard(thread), PATCH_DELAY);
}

function scan() {
  document.querySelectorAll(THREAD).forEach(enhanceThread);
}

if (typeof window !== 'undefined') {
  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
}
